// extracted by mini-css-extract-plugin
export default {"plus":"Plus_plus__eEAoG"};